import { Body1, Button, GetColor } from 'venn-ui-kit';
import { plural } from 'venn-utils';
import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';
import { cn } from '@/lib/utils';

interface PortfoliosTableAnnotationParams {
  bulkActionsComponent: ReactNode;
  userSelectedRowsCount: number;
  totalRowsCount: number;
  clearAllFilters: () => void;
  hasActiveFilters?: boolean;
  children?: ReactNode;
}

export const PortfoliosTableAnnotation = ({
  bulkActionsComponent,
  userSelectedRowsCount,
  totalRowsCount,
  clearAllFilters,
  hasActiveFilters = false,
  children,
}: PortfoliosTableAnnotationParams) => {
  return userSelectedRowsCount ? (
    <ActionsContainer>
      <Body1>{userSelectedRowsCount} Selected</Body1>
      <ItemsSelectedDivider />
      {bulkActionsComponent}
    </ActionsContainer>
  ) : (
    <FilterPillContainer className={cn('qa-filter-pills min-h-[36px]')}>
      <ResultCount>{plural(totalRowsCount, { 1: '{{count}} result', other: '{{count}} results' })}</ResultCount>
      {hasActiveFilters && (
        <>
          <ItemsSelectedDivider />
          <div className={cn('flex flex-nowrap overflow-auto gap-[4px]')}>{children}</div>
          <Button className="qa-clear-all" flat onClick={clearAllFilters}>
            <span className="text-venn-error">Clear All</span>
          </Button>
        </>
      )}
    </FilterPillContainer>
  );
};

const ItemsSelectedDivider = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin: 0 13px 0 19px;
  width: 1px;
  height: 24px;
  border: solid 0.5px ${GetColor.GreyScale.Grey40};
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FilterPillContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: calc(100% - 100px);
`;

const ResultCount = styled(Body1)`
  white-space: nowrap;
`;
